export function useCookie(name: string) {
    const cookieValue = global.document?.cookie
        .split('; ')
        .find(row => row.startsWith(`${name}=`));

    return cookieValue?.split('=')[1];
}
